import { readDesktopPrimaryBearerToken } from "./desktopAuth";
import { resolvePrimaryEnvironmentHttpUrl } from "./target";
import { noteWorldResponse } from "../../neucleos/worldReachability";
import { isWebHost, needsTheMacResponse } from "../../webHost";
import { answerWebHostWorldDoor } from "../../neucleos/webHostWorldDoors";

/** Fetch a primary-environment route using the same credentials as its RPC client. */
export async function fetchPrimary(path: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (
    typeof path !== "string" ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    path.includes("\\")
  ) {
    throw new Error("Expected a primary-environment route path.");
  }
  // cleo-web (webHost.ts): no Mac server stands behind this page. The World doors the window can read itself answer
  // from the World, in the server's own shape (webHostWorldDoors.ts); every other Desk route answers the one refusal,
  // so each screen shows its own failure words, and the World is never read as "not answering" for it.
  if (isWebHost()) {
    const answered = await answerWebHostWorldDoor(path, init);
    if (answered === null) return needsTheMacResponse(path);
    void noteWorldResponse(path, answered).catch(() => undefined);
    return answered;
  }
  const token = await readDesktopPrimaryBearerToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set("authorization", `Bearer ${token}`);
  const route = new URL(path, "http://primary.invalid");
  const url = new URL(resolvePrimaryEnvironmentHttpUrl(route.pathname));
  url.search = route.search;
  const response = await fetch(url.toString(), {
    ...init,
    headers,
    credentials: token ? "omit" : "include",
  });
  // W-d4a5a81b: a World read the World did not answer is told to the person
  // once, Desk-wide, instead of each door going quietly empty.
  void noteWorldResponse(route.pathname, response).catch(() => undefined);
  return response;
}
